const signup = {
  advantages: {
    title: 'Sie haben noch kein Konto?',
    subtitle: 'Immer bestens informiert mit für Sie relevanten Gesundheitstipps und individuellen Angeboten:',
    steps: {
      1: {
        title: 'Exklusive Angebote',
        text: 'von Ihrer Apotheke vor Ort',
      },
      2: {
        title: 'Aktuelle Gesundheitsthemen',
        text: 'und -trends',
      },
      3: {
        title: 'Attraktive Coupons',
        text: 'und Hersteller-Rabatte',
      },
      4: {
        title: 'Persönliche Empfehlungen',
        text: 'für Ihre Gesundheit',
      },
      5: {
        title: 'my life als kostenloses E-Paper',
        text: '- bleiben Sie top informiert über alle relevanten Gesundheitsthemen',
      },
    },
  },
}

export default signup
